/**
 * @file Optimistically update the cache, setting user status to be deactivated
 */

import { OptimisticMutationResolver } from '@urql/exchange-graphcache';

import {
  MutationUserDeactivateArgs,
  UserDeactivateMutation,
  UserStatus,
} from '../../../../../generated/graphql';
import { getSettingsUserById } from '../../updates/utils/getters/settings';

/**
 * Optimistically set user status to be deactivated
 *
 * @param args  Arguments of a graphQL operation
 * @param cache URQL graphQL cache
 * @returns     Optimistic updates or null
 */
const userDeactivate: OptimisticMutationResolver<
  MutationUserDeactivateArgs,
  UserDeactivateMutation['userDeactivate'] | null
> = (args, cache) => {
  const user = getSettingsUserById(cache, args.id);

  if (user === null) {
    return null;
  }

  return {
    ...user,
    __typename: 'User',
    status: UserStatus.DEACTIVATED,
  };
};

export default userDeactivate;
